import api from "./api";

export const uploadScholarProfile = async (
  scholarId,
  file,
  // remove = 1
) => {

  const formData = new FormData();

  formData.append("scholar_profile", file);
  // formData.append("remove", remove);

  const response = await api.post(
    `/scholar/profile/${scholarId}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
};


export const deleteScholarProfile = async (scholarId) => {

  const formData = new FormData();

  formData.append("remove", 1);

  const response = await api.post(
    `/scholar/profile/${scholarId}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
};